import styled from "styled-components";

import { theme } from "@tm/utility/global";

export const ResultPage = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 40px 16px 56px;
  box-sizing: border-box;
  background: ${theme.whiteText};
`;

export const ResultContent = styled.div`
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Animation = styled.img`
  width: 180px;
  height: 180px;
  object-fit: contain;
  margin-bottom: 24px;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 900;
  line-height: 1.3;
  color: ${theme.blackText2};
  margin: 0 0 12px;
`;

export const ResultCopy = styled.p<{
  $mb?: string;
  $maxWidth?: string;
  $size?: string;
  $lh?: string;
}>`
  font-size: ${(p) => p.$size ?? "14px"};
  line-height: ${(p) => p.$lh ?? "1.4"};
  color: ${theme.greyText6};
  margin: 0 0 ${(p) => p.$mb ?? "16px"};
  max-width: ${(p) => p.$maxWidth ?? "none"};
`;

export const ReferenceValue = styled.span`
  font-weight: 500;
`;

export const ClaimCardBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 12px;
  padding: 16px 18px;
  text-align: left;
  margin-bottom: 20px;
  background: linear-gradient(
    90deg,
    ${theme.lightBlueBg} 0%,
    ${theme.whiteText} 100%
  );
  box-sizing: border-box;

  > div {
    flex: 1;
    min-width: 0;
  }

  img {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    object-fit: contain;
  }
`;

export const ClaimCardTitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  color: ${theme.blackText2};
  margin: 0 0 6px;
`;

export const ClaimCardMeta = styled.p`
  font-size: 13px;
  line-height: 1.4;
  color: ${theme.greyText6};
  margin: 0;
`;

export const FullWidthPrimaryButton = styled.button`
  width: 100%;
  margin-top: 4px;
  margin-bottom: 8px;
  border: none;
  border-radius: 8px;
  background: ${theme.blueText};
  color: ${theme.whiteText};
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  padding: 12px 18px;
  cursor: pointer;

  &:hover:not(:disabled) {
    opacity: 0.92;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const SecondaryLink = styled.button`
  border: none;
  background: transparent;
  color: ${theme.blueText};
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  text-decoration: underline;
  text-underline-offset: 3px;
  padding: 4px 0;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`;
